"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findTheOneTrueOutputLayer = findTheOneTrueOutputLayer;

function findTheOneTrueOutputLayer(macroId, layers) {
  // Return nothing on bad input.
  if (!macroId || !layers || !Array.isArray(layers) || layers.length === 0) {
    return null;
  }

  return layers // Filter layers that aren't for the requested macro and that don't have input layers
  .filter(function (layer) {
    return layer.macroId === macroId && layer.inputAnnotationId;
  }) // Now just find the newest layer that has regions
  .reduce(function (layerToReturn, potentialLayerToReturn) {
    if (!layerToReturn) {
      layerToReturn = potentialLayerToReturn;
    } // If the current candidate layer has no regions and the test layer has regions, prefer the test layer


    if (layerToReturn.regions.length === 0 && potentialLayerToReturn.regions.length > 0) {
      return potentialLayerToReturn;
    } // Otherwise, prefer the newer layer (newer by proxy)


    return layerToReturn.id > potentialLayerToReturn.id ? layerToReturn : potentialLayerToReturn;
  }, null);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/lbs-pi-platform-access/es/data-server/image-analysis/util.js
// module id = 56
// module chunks = 0